import React from 'react';
import { format } from 'date-fns';

interface Reading {
  id: string | number;
  date: string;
  daily_kwh: number;
  total_kwh: number;
}

interface ReadingsTableProps {
  readings: Reading[];
}

const ReadingsTable: React.FC<ReadingsTableProps> = ({ readings }) => {
  // Sort readings by date descending (newest first) and take last 7
  const sortedReadings = [...readings]
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, 7);

  // Pre-compute running kWh totals for the displayed week (oldest to newest)
  const cumulativeValues = sortedReadings.map((_, i) => {
    let sum = 0;
    for (let j = sortedReadings.length - 1; j >= i; j--) {
      sum += sortedReadings[j].daily_kwh;
    }
    return sum;
  });

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-300">
        <thead>
          <tr className="bg-gray-50">
            <th className="border border-gray-300 px-4 py-2 text-left" rowSpan={2}></th>
            {sortedReadings.map((reading) => (
              <th key={reading.id} className="border border-gray-300 px-4 py-2 text-center">
                <div>{format(new Date(reading.date), 'EEEE')}</div>
                <div className="text-sm font-normal">{format(new Date(reading.date), 'dd/MM/yy')}</div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border border-gray-300 px-4 py-2 font-medium font-sans">Daily (kwh):</td>
            {sortedReadings.map((reading) => (
              <td key={reading.id} className="border border-gray-300 px-4 py-2 text-center">
                {reading.daily_kwh}
              </td>
            ))}
          </tr>
          <tr className="bg-gray-50">
            <td className="border border-gray-300 px-4 py-2 font-medium font-sans">Total (kwh):</td>
            {sortedReadings.map((reading) => (
              <td key={reading.id} className="border border-gray-300 px-4 py-2 text-center">
                {reading.total_kwh.toLocaleString()}
              </td>
            ))}
          </tr>
          <tr>
            <td className="border border-gray-300 px-4 py-2 font-medium font-sans">Cumulative (kWh):</td>
            {sortedReadings.map((reading, index) => (
              <td key={reading.id} className="border border-gray-300 px-4 py-2 text-center">
                {cumulativeValues[index].toFixed(2)}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ReadingsTable;
